<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item url="/dashboard-default" :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          navText="Métricas">
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <!--   <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/models" :class="getRoute() === 'models' ? 'active' : ''" navText="Referencias">
          <template v-slot:icon>
            <i class="fas fa-cubes text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/production" :class="getRoute() === 'production' ? 'active' : ''" navText="Producción">
          <template v-slot:icon>
            <i class="fas fa-industry text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

       <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/oven" :class="getRoute() === 'oven' ? 'active' : ''" navText="Horno">
          <template v-slot:icon>
            <i class="fas fa-fire text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/users" :class="getRoute() === 'users' ? 'active' : ''" navText="Usuarios">
          <template v-slot:icon>
            <i class="fas fa-users text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/supplies" :class="getRoute() === 'supplies' ? 'active' : ''" navText="Inventario">
          <template v-slot:icon>
            <i class="fas fa-box text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

     <!--  <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/inventory" :class="getRoute() === 'inventory' ? 'active' : ''" navText="Inventario">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->


      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/mines-extractions" :class="getRoute() === 'mines-extractions' ? 'active' : ''"
          navText="Minas">
          <template v-slot:icon>
            <i class="fas fa-truck text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role === '3'">
        <sidenav-item url="/operator/production-user" :class="$route.path === '/operator/production-user' ? 'active' : ''"
          navText="Producción">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <li class="nav-item" v-if="false">
        <sidenav-item url="/purchases" :class="getRoute() === 'purchases' ? 'active' : ''" navText="Compras">
          <template v-slot:icon>
            <i class="fas fa-shopping-cart text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/remissions" :class="getRoute() === 'remissions' ? 'active' : ''" navText="Despachos">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/transfers" :class="getRoute() === 'transfers' ? 'active' : ''" navText="Transferencias">
          <template v-slot:icon>
            <i class="fas fa-exchange-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/nomina" :class="getRoute() === 'nomina' ? 'active' : ''" navText="Nomina">
          <template v-slot:icon>
            <i class="fas fa-money-bill text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="false">
        <sidenav-item url="/machinery" :class="getRoute() === 'machinery' ? 'active' : ''" navText="Maquinaria">
          <template v-slot:icon>
            <i class="fas fa-cogs text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      
      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/map" :class="$route.path === '/map' ? 'active' : ''" navText="Mapa">
          <template v-slot:icon>
            <i class="fas fa-map text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="false">
        <sidenav-item url="/map/designer" :class="$route.path === '/map/designer' ? 'active' : ''"
          navText="Mapa dinámico">
          <template v-slot:icon>
            <i class="fas fa-draw-polygon text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- Reportes oculto
      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/reports" :class="getRoute() === 'reports' ? 'active' : ''" navText="Informes">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      -->

      <li class="nav-item" v-if="user?.role === '1' || user?.role === '2'">
        <sidenav-item url="/settings" :class="getRoute() === 'settings' ? 'active' : ''" navText="Configuración">
          <template v-slot:icon>
            <i class="fas fa-cog text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

    </ul>
  </div>
  <div class="mx-3 sidenav-footer text-center mt-3">


  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";


export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
      user: {}
    };
  },
  components: {
    SidenavItem,
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.user = user;
    }
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },

  },
};
</script>
